import { makeStyles } from "@material-ui/core/styles";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useCallback, useState } from "react";
import Ukmet from "../layers/Ukmet";
import { weatherTimeWithID, WX_ID_UKMET } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";

const useStyles = makeStyles(_ => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  checkLabel: {
    fontSize:"12px"
  },
  subItem: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '0px'
  },
  itemBlock: {
    fontSize: '1.2rem',
    lineHeight: '34px'
  },
  contour:{
    display: 'inline-block',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '35px',
    height: '5px',
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      top: "22px",
      left: 0,
      width: '35px'
    }
  },
  lt100: {
    color: "rgb(22, 176, 254)",
    '&:after': {
      borderTop: '4px solid rgb(22, 176, 254)'
    }
  },
  gt100: {
    color:"rgb(11, 141, 11)",
    '&:after': {
      borderTop: '4px solid rgb(144, 238, 144)'
    }
  },
  gt160: {
    color:"rgb(244, 150, 44)",
    '&:after': {
      borderTop: '4px solid rgb(244, 150, 44)'
    }
  },
  isothermNormal: {
    color: "rgb(107,0,2)",
    '&:after': {
      borderTop: '4px solid rgb(107,0,2)'
    }
  },
  isothermModerate: {
    color: "rgb(107,0,2)",
    '&:after': {
      borderTop: '4px solid rgb(255, 255, 11)'
    }
  },
  isothermSevere: {
    color: "rgb(107,0,2)",
    '&:after': {
      borderTop: '4px solid rgb(251, 0, 6)'
    }
  },
  geoPotentialHeight: {
    '&:after': {
      top: 0,
      left: '5px',
      borderTop: '4px solid rgb(0, 255, 0)'
    }
  },
}));


function LegendUkmet({contents: ukmet}) {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_UKMET));
  const [contentsState, setContentsState] = useState(ukmet.getContentsVisibleState());

  const toggleContents = useCallback(event => {
    ukmet.setVisible(event.target.checked, event.target.name);
    setContentsState({...contentsState, [event.target.name]:event.target.checked});
  }, [ukmet, contentsState]);

  return (
    <div>
      <div className="legend-contents-time">
        {timeInfo.validTime}&nbsp;{timeInfo.baseTime}
      </div>
      <ul className={classes.box}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.WIND_ARROW_NAME]} onChange={toggleContents} name={Ukmet.WIND_ARROW_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Wind</span>}
          />
        </li>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.WIND_STREAM_NAME]} onChange={toggleContents} name={Ukmet.WIND_STREAM_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Stream</span>}
          />
        </li>
      </ul>
      <ul className={classes.box}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTACH_NAME]} onChange={toggleContents} name={Ukmet.ISOTACH_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Isotach</span>}
          />
        </li>
        <li className={classes.subItem + ' ' + classes.itemBlock}>(</li>
        <li className={classes.subItem}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTACH_CONTOUR_NAME]} onChange={toggleContents} name={Ukmet.ISOTACH_CONTOUR_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Contour</span>}
          />
        </li>
        <li className={classes.subItem}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTACH_MESH_NAME]} onChange={toggleContents} name={Ukmet.ISOTACH_MESH_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Fill</span>}
          />
        </li>
        <li className={classes.subItem + ' ' + classes.itemBlock}>)</li>
        <li className={classes.item}>
          <span className={classes.contour+ ' ' + classes.lt100}>&lt;100kt</span>
        </li>
        <li className={classes.item}>
          <span className={classes.contour + ' ' + classes.gt100}>100kt</span>
        </li>
        <li className={classes.item}>
          <span className={classes.contour + ' ' + classes.gt160}>160kt</span>
        </li>
      </ul>
      <ul className={classes.box}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTHERM_NAME]} onChange={toggleContents} name={Ukmet.ISOTHERM_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Isotherm</span>}
          />
        </li>
        <li className={classes.subItem + ' ' + classes.itemBlock}>(</li>
        <li className={classes.subItem}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTHERM_CONTOUR_NAME]} onChange={toggleContents} name={Ukmet.ISOTHERM_CONTOUR_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Contour</span>}
          />
        </li>
        <li className={classes.subItem}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTHERM_MESH_NAME]} onChange={toggleContents} name={Ukmet.ISOTHERM_MESH_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Fill</span>}
          />
        </li>
        <li className={classes.subItem}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ISOTHERM_GRID_NAME]} onChange={toggleContents} name={Ukmet.ISOTHERM_GRID_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Grid</span>}
          />
        </li>
        <li className={classes.item + ' ' + classes.itemBlock}>)</li>
        <li className={classes.item}>
          <span className={classes.contour+ ' ' + classes.isothermNormal}>&gt;-64c</span>
        </li>
        <li className={classes.item}>
          <span className={classes.contour + ' ' + classes.isothermModerate}>-65c</span>
        </li>
        <li className={classes.item}>
          <span className={classes.contour + ' ' + classes.isothermSevere}>-68c</span>
        </li>
      </ul>
      <ul className={classes.box}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.GEO_POTENTIAL_HEIGHT_NAME]} onChange={toggleContents} name={Ukmet.GEO_POTENTIAL_HEIGHT_NAME} size='small'/>}
            label={
              <>
              <span className={classes.checkLabel}>Geo Potential Height</span>
              <span className={classes.contour + ' ' + classes.geoPotentialHeight}/>
              </>
            }
          />
        </li>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[Ukmet.ICING_PROB_NAME]} onChange={toggleContents} name={Ukmet.ICING_PROB_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>IcingProb</span>}
          />
        </li>
      </ul>
    </div>
  )
}

export default LegendUkmet;